module.exports = __webpack_public_path__ + "static/media/owen.4c85ec13.jpg";